import React from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CustomAccordion from '../../../CustomAccordion/CustomAccordion';

import './PatientInformationSurgicalTimeAndPersonnel.scss'
import { calculateCurrentDuration } from '../../../../utils/fuctions'

const PatientInformationSurgicalTimeAndPersonnel = ({
  form,
  formData,
  arrayIndex,
  onChangeHandler,
  onRemoveHandler,
  showToggleButtons = false,
  filterType = 'include',
  onFilterTypeChange = () => {},
  activeKey,
  onAccordionChange = () => {},
  closeFromBottom = false
}) => {
  const handleAccordionToggle = () => {
    onAccordionChange(form);
  };
  switch(form) {
    case "patientInformation": {
      // Custom preview that uses calculateCurrentDuration for durationOfSymptoms
      const previewDataWithCalculatedDuration = Object.entries(formData)
        .filter(([key]) => !['symptomDurationEntryDate', 'eventDate'].includes(key))
        .reduce((acc, [key, value]) => {
          const displayValue = key === 'durationOfSymptoms'
            ? calculateCurrentDuration(formData.durationOfSymptoms, formData.symptomDurationEntryDate, formData.surgeryDate)
            : value;
          acc[key] = displayValue;
          return acc;
        }, {});

      return (
        <CustomAccordion
          title="Patient Information"
          previewData={previewDataWithCalculatedDuration}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="patient-information"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
          <Form>
            <Row>
              <Col>
                <Form.Label>Weight</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={500}
                  value={formData.weight}
                  onChange={(e) => {onChangeHandler(arrayIndex, "weight", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Height</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={300}
                  value={formData.height}
                  onChange={(e) => {onChangeHandler(arrayIndex, "height", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Smoker?</Form.Label>
                <Form.Select
                  value={formData.smoker}
                  onChange={(e) => {onChangeHandler(arrayIndex, "smoker", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </Col>
              <Col>
                <Form.Label>Diabetic?</Form.Label>
                <Form.Select
                  value={formData.diabetic}
                  onChange={(e) => {onChangeHandler(arrayIndex, "diabetic", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Workman's compensation case?</Form.Label>
                <Form.Select
                  value={formData.workmansCompensationCase}
                  onChange={(e) => {onChangeHandler(arrayIndex, "workmansCompensationCase", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
            </Col>
            <Col>
              <Form.Label>Pre-operative use narcotics?</Form.Label>
              <Form.Select
                value={formData.preOperativeUseOfNarcotics}
                onChange={(e) => {onChangeHandler(arrayIndex, "preOperativeUseOfNarcotics", e.target.value)}}
              >
                <option value="" hidden>Select an option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Select>
            </Col>
            </Row>
            <Row>
              <Col>
                  <Form.Label>BMI</Form.Label>
                  <Form.Control
                    type="number"
                    step={0.1}
                    min={0}
                    max={100}
                    value={formData.bmi}
                    disabled={true}
                  ></Form.Control>
                </Col>
              <Col>
                <Form.Label>Duration of symptoms (months)</Form.Label>
                <Form.Control
                  type="number"
                  step={0.1}
                  min={0}
                  max={999}
                  value={calculateCurrentDuration(formData.durationOfSymptoms, formData.symptomDurationEntryDate, formData.eventDate)}
                  onChange={(e) => {onChangeHandler(arrayIndex, "durationOfSymptoms", e.target.value)}}
                ></Form.Control>
                {formData.symptomDurationEntryDate && (
                  <small className="text-muted">
                    Auto-calculated from {formData.durationOfSymptoms} months
                    entered on {new Date(formData.symptomDurationEntryDate).toLocaleDateString('en-GB')}
                    {formData.durationOfSymptoms !== calculateCurrentDuration(formData.durationOfSymptoms, formData.symptomDurationEntryDate, formData.surgeryDate) &&
                      ` (originally ${formData.durationOfSymptoms} months)`
                    }
                  </small>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Profession</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.profession}
                  onChange={(e) => {onChangeHandler(arrayIndex, "profession", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Principal sport</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.principalSport}
                  onChange={(e) => {onChangeHandler(arrayIndex, "principalSport", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
          </Form>
        </CustomAccordion>
      )
    }
    case "patientInformationForAnalysis": {
      return (
        <CustomAccordion
          title="Patient Information"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="patient-information"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
          <Form>
            <Row>
              <Col>
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  value={formData.gender}
                  onChange={(e) => {onChangeHandler(arrayIndex, "gender", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </Form.Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Smoker?</Form.Label>
                <Form.Select
                  value={formData.smoker}
                  onChange={(e) => {onChangeHandler(arrayIndex, "smoker", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </Col>
              <Col>
                <Form.Label>Diabetic?</Form.Label>
                <Form.Select
                  value={formData.diabetic}
                  onChange={(e) => {onChangeHandler(arrayIndex, "diabetic", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Workman's compensation case?</Form.Label>
                <Form.Select
                  value={formData.workmansCompensationCase}
                  onChange={(e) => {onChangeHandler(arrayIndex, "workmansCompensationCase", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
            </Col>
            <Col>
              <Form.Label>Pre-operative use narcotics?</Form.Label>
              <Form.Select
                value={formData.preOperativeUseOfNarcotics}
                onChange={(e) => {onChangeHandler(arrayIndex, "preOperativeUseOfNarcotics", e.target.value)}}
              >
                <option value="" hidden>Select an option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Select>
            </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Profession</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.profession}
                  onChange={(e) => {onChangeHandler(arrayIndex, "profession", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Principal sport</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.principalSport}
                  onChange={(e) => {onChangeHandler(arrayIndex, "principalSport", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
          </Form>
        </CustomAccordion>
      )
    }
    case "surgicalTimeAndPersonnel": {
      return (
        <CustomAccordion
          title="Surgical Time and Personnel"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="patient-information"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
          <Form>
            <Row>
              <Col>
                <Form.Label>Surgical Time</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={500}
                  value={formData.surgicalTime}
                  onChange={(e) => {onChangeHandler(arrayIndex, "surgicalTime", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Number of Surgical Techs</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={300}
                  value={formData.numberOfSurgicalTechs}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfSurgicalTechs", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Number of PAs</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={500}
                  value={formData.numberOfPas}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfPas", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Number of Surgical Assistants</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={300}
                  value={formData.numberOfSurgicalAssistants}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfSurgicalAssistants", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Number of Nurses</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={500}
                  value={formData.numberOfNurses}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfNurses", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Number of Surgeons</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={300}
                  value={formData.numberOfSurgeons}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfSurgeons", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Number of Fellows</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={500}
                  value={formData.numberOfFellows}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfFellows", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Number of Residents</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={300}
                  value={formData.numberOfResidents}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfResidents", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Number of NPs (Nurse practitioner)</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={500}
                  value={formData.numberOfNursePractitioners}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfNursePractitioners", e.target.value)}}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>Number of Certified Orthopedic Technologist required</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={300}
                  value={formData.numberOfOrthopedicTechnologists}
                  onChange={(e) => {onChangeHandler(arrayIndex, "numberOfOrthopedicTechnologists", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
          </Form>
        </CustomAccordion>
      )
    }
    default: {
      return null
    }
  }
}

export default PatientInformationSurgicalTimeAndPersonnel